import React, { useEffect, useRef } from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Image } from "expo-image";
import { useGlobal } from "@/Components/Context/globalContext";
import { Audio } from "expo-av";

export default function PreviTrucada(RouterData: any) {
  const { __, textRecurs, imatgeRecurs, projecte } = useGlobal();
  const soundRef = useRef<Audio.Sound | null>(null);

  const { itinerari, premi } = RouterData.route.params;

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const { sound } = await Audio.Sound.createAsync(
        require("@/assets/Sounds/call.mp3"),
        { shouldPlay: true, isLooping: true, volume: 1 },
      );
      if (cancelled) {
        sound.stopAsync();
        sound.unloadAsync();
        return;
      }
      soundRef.current = sound;
    })();

    return () => {
      cancelled = true;
      soundRef.current?.stopAsync();
      soundRef.current?.unloadAsync();
    };
  }, []);

  const stopSound = () => {
    soundRef.current?.stopAsync();
    soundRef.current?.unloadAsync();
  };

  const closeCall = () => {
    stopSound();
    RouterData.navigation.replace("Valoracions", RouterData.route.params);
  };
  const goCall = () => {
    stopSound();
    RouterData.navigation.replace("Trucada", RouterData.route.params);
  };

  return (
    <View style={{ flex: 1, backgroundColor: "#000", paddingVertical: 40 }}>
      <View style={{ flex: 60, justifyContent: "center" }}>
        <View
          style={{
            flex: 1,
            alignSelf: "center",
          }}
        >
          <View style={{ flex: 1 }}>
            <Text style={style.text}>{__(premi, "popup_titol")}</Text>
          </View>
          <View
            style={{
              flex: 1,
            }}
          >
            <Image
              placeholder={require("@/assets/Images/loading.gif")}
              source={{
                uri: __(premi, "multimedia")?.url,
              }}
              style={{
                flex: 1,
              }}
              contentFit={"cover"}
            />
          </View>
        </View>
      </View>

      <View style={{ flex: 10 }} />

      {/* Agafar/penjar icones  */}
      <View style={{ flex: 20 }}>
        <View
          style={{
            flex: 1,
            alignSelf: "center",
            width: "100%",
            height: "100%",
            flexDirection: "row",
            alignContent: "center",
          }}
        >
          <TouchableOpacity
            onPress={() => {
              goCall();
            }}
            style={{ width: "50%", height: "60%", alignSelf: "center" }}
          >
            <Image
              style={{ width: "100%", height: "100%", resizeMode: "contain" }}
              source={{
                uri: imatgeRecurs("boton_aceptar_llamada"),
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => closeCall()}
            style={{ width: "50%", height: "60%", alignSelf: "center" }}
          >
            <Image
              style={{ width: "100%", height: "100%", resizeMode: "contain" }}
              source={{ uri: imatgeRecurs("boton_colgar") }}
            />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const style = StyleSheet.create({
  text: {
    color: "white",
    textAlign: "center",
    alignItems: "center",
    fontSize: 50,
    fontWeight: "bold",
  },
});
